/**
 * Converts a UNIX timestamp to a formatted time string.
 *
 * @param {number} timestamp - The UNIX timestamp to convert.
 * @return {string} The formatted time string in "HH:MM AM/PM" format.
 */
export const timestampToTime = (timestamp: number): string => {
  const timestampDate = new Date(timestamp)

  return timestampDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
  })
}

/**
 * Returns the first day of a future month in UTC time.
 *
 * @param {number} monthsAhead - The number of months ahead to get the first day of.
 * @return {number} The first day of the future month in UNIX timestamp format.
 */
export const getFirstDayOfFutureMonth = (monthsAhead: number): number => {
  const month = new Date()
  month.setUTCMonth(month.getUTCMonth() + monthsAhead)
  month.setUTCDate(1)
  month.setUTCHours(0, 0, 0, 0)

  return month.getTime()
}
